import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
import { DiagnosisConditionsService } from "./diagnosis-conditions.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import "rxjs-spy/add/operator/tag";
import { Observable } from "rxjs/Observable";
var DiagnosisWidgetService = /** @class */ (function () {
    function DiagnosisWidgetService(store, conditionsService) {
        // const objectCompareFunction = (a, b) => JSON.stringify(a) === JSON.stringify(b);
        var _this = this;
        this.store = store;
        this.conditionsService = conditionsService;
        this.valid$ = new BehaviorSubject(false);
        this.validItem$ = new BehaviorSubject(null);
        this.diagnosisOdontogram$ = new BehaviorSubject(null);
        this.odontogram$ = new BehaviorSubject(null);
        // diagnosis odontogram
        Observable.combineLatest(store
            .select(fromRoot.getOdontogram)
            .distinctUntilChanged()
            .tag("diagnosis/getOdontogram"), store
            .select(fromRoot.getDiagnosisItems)
            .tag("diagnosis/getDiagnosisItems"))
            .map(function (_a) {
            var odontogram = _a[0], diagnosisItems = _a[1];
            return _this.computeOdontogram(odontogram, diagnosisItems);
        })
            .tag("diagnosis/diagnosisOdontogram$")
            .subscribe(this.diagnosisOdontogram$);
        // valid
        store
            .select(fromRoot.getDiagnosisCurrentItemFull)
            .tag("diagnosis/getDiagnosisCurrentItemFull")
            .withLatestFrom(this.diagnosisOdontogram$)
            .map(function (_a) {
            var currentItem = _a[0], odontogram = _a[1];
            return [
                currentItem,
                _this.checkIfValid(odontogram, currentItem),
            ];
        })
            .tag("diagnosis/valid$")
            .do(function (_a) {
            var currentItem = _a[0], valid = _a[1];
            _this.valid$.next(valid);
            if (!valid) {
                _this.validItem$.next(null);
            }
        })
            .filter(function (_a) {
            var currentItem = _a[0], valid = _a[1];
            return valid;
        })
            .map(function (_a) {
            var currentItem = _a[0];
            return currentItem;
        })
            .tag("diagnosis/validItem$")
            .subscribe(this.validItem$);
        // final odontogram
        Observable.combineLatest(this.diagnosisOdontogram$, this.validItem$)
            .map(function (_a) {
            var odontogram = _a[0], item = _a[1];
            return _this.computeOdontogram(odontogram, item ? [item] : []);
        })
            .tag("diagnosis/odontogram$")
            .subscribe(this.odontogram$);
    }
    DiagnosisWidgetService.prototype.computeOdontogram = function (odontogram, items) {
        var _this = this;
        // create a copy of odontogram
        var updatedOdontogram = [];
        odontogram.forEach(function (x) {
            var copy = Object.assign({}, x);
            copy.diagnosis = x.diagnosis.slice();
            updatedOdontogram.push(copy);
        });
        if (items.length > 0) {
            items.forEach(function (item) {
                var conditionClass = _this.conditionsService.getClassForCondition(item.condition);
                if (conditionClass) {
                    conditionClass.apply(updatedOdontogram, item);
                }
                else {
                    console.log("condition not supported " + item.condition);
                }
            });
        }
        return updatedOdontogram;
    };
    DiagnosisWidgetService.prototype.checkIfValid = function (odontogram, currentItem) {
        // no condition selected, so the item is not valid
        if (!currentItem.condition) {
            return false;
        }
        var conditionClass = this.conditionsService.getClassForCondition(currentItem.condition);
        if (conditionClass) {
            return conditionClass.validate(currentItem, odontogram, []);
        }
        else {
            console.log("condition not supported", currentItem);
        }
        return false;
    };
    DiagnosisWidgetService.prototype.getOdontogram = function () {
        return this.odontogram$;
    };
    DiagnosisWidgetService.prototype.isValid = function () {
        return this.valid$;
    };
    return DiagnosisWidgetService;
}());
export { DiagnosisWidgetService };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/diagnosis-widget.service.ts.pre-build-optimizer.js